import { FC } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Navigation from './components/Navigation.tsx';
import Hero from './components/Hero.tsx';
import Projects from './components/Projects.tsx';
import RealWorldProjectDetail from './components/RealWorldProjectDetail.tsx';
import Footer from './components/Footer.tsx';

const App: FC = () => {
  return (
    <Router>
      <AppContainer>
        <Navigation />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Projects />
            </>
          } />
          <Route path="/make/:id" element={<RealWorldProjectDetail />} />
        </Routes>
        <Footer />
      </AppContainer>
    </Router>
  );
};

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export default App;
